/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon24Solid = forwardRef('People1MinusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 13a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" }),
        React.createElement("path", { d: "M2.179 20.01C3.264 14.394 9.015 14 12 14c2.253 0 6.082.225 8.291 2.75H15A3.25 3.25 0 0 0 12.438 22H4c-1.105 0-2.03-.906-1.821-1.99Z" }),
        React.createElement("path", { d: "M14 20c0-.69.56-1.25 1.25-1.25h7.5a1.25 1.25 0 1 1 0 2.5h-7.5c-.69 0-1.25-.56-1.25-1.25Z" })));
});
